import React from 'react';
import {
  Github,
  Linkedin,
  Mail,
  ArrowUpRight,
  ArrowRight,
  ArrowDownRight,
  X,
  Lock,
  Briefcase,
  Code,
  Book,
  Play,
  ExternalLink,
  GraduationCap,
  Layers,
  Boxes,
  Network,
  Server,
  Workflow,
  Gauge,
  Cpu,
} from 'lucide-react';

/* Maps the design system's Lucide icon names (kebab-case) to
   lucide-react components, so JSX can stay `<Icon name="arrow-right" />`. */
const ICONS = {
  github: Github,
  linkedin: Linkedin,
  mail: Mail,
  'arrow-up-right': ArrowUpRight,
  'arrow-right': ArrowRight,
  'arrow-down-right': ArrowDownRight,
  x: X,
  lock: Lock,
  briefcase: Briefcase,
  code: Code,
  book: Book,
  play: Play,
  'external-link': ExternalLink,
  'graduation-cap': GraduationCap,
  layers: Layers,
  boxes: Boxes,
  network: Network,
  server: Server,
  workflow: Workflow,
  gauge: Gauge,
  cpu: Cpu,
};

export function Icon({ name, size = 18, strokeWidth = 2, style, ...rest }) {
  const Cmp = ICONS[name];
  if (!Cmp) return null;
  return (
    <span style={{ display: 'inline-flex', lineHeight: 0, ...style }}>
      <Cmp size={size} strokeWidth={strokeWidth} {...rest} />
    </span>
  );
}

export default Icon;
